export default class Table
{
	static init()
	{
		this._tab()
	}

	static _tab()
	{
		const list = $('.__tab')
		if(list.length === 0) return

		const name = []
		list.find('a').each((index, element) => name.push(element.getAttribute('data-tab')))

		list.find('a').on('click', element =>
		{
			for(const key of name)
			{
				$(`#${key}`).hide()
				$(`.__tab a[data-tab="${key}"]`).removeClass('__tab_active')
			}

			const tab = element.target.getAttribute('data-tab')

			$(`.__tab a[data-tab="${tab}"]`).addClass('__tab_active')
			$(`#${tab}`).fadeIn()
		})

		list.find('a').first().trigger('click')
	}
}
